import app from 'modules/core/store/models/app'

const handleResultWithFlash = (callback?: () => void) => {
  return (response: Record<string, string>) => {
    const message =
      'errors' in response
        ? response.errors
        : 'messages' in response
        ? response.messages
        : Object.values(response).join(', ')

    app.setFlash({
      type: 'wrong',
      message: message,
    })

    if (callback) {
      callback()
    }
  }
}

export default handleResultWithFlash
